const STORAGE_KEY = 'postLoginRedirect'

/** Paths we never restore after OAuth (login screens, public entry). */
function isUselessRedirect(pathWithSearch: string): boolean {
  const path = pathWithSearch.split('?')[0] || '/'
  if (path === '/' || path === '/intranet') return true
  if (path.startsWith('/auth/')) return true
  if (path === '/guest' || path === '/privacy-policy' || path === '/gdpr') return true
  return false
}

export function savePostLoginRedirect(pathWithSearch: string): void {
  if (!pathWithSearch || isUselessRedirect(pathWithSearch)) return
  try {
    sessionStorage.setItem(STORAGE_KEY, pathWithSearch)
  } catch {
    /* ignore quota / private mode */
  }
}

export function consumePostLoginRedirect(fallback = '/intranet'): string {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_KEY)
    if (saved && !isUselessRedirect(saved) && saved.startsWith('/')) {
      return saved
    }
  } catch {
    /* ignore */
  }
  return fallback
}

/** Drop a single query key from the current location (keeps other params). */
export function stripSearchParam(search: string, key: string): string {
  const params = new URLSearchParams(search)
  params.delete(key)
  const next = params.toString()
  return next ? `?${next}` : ''
}
